import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  Typography,
  Grid,
  Box,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import RestoreIcon from '@mui/icons-material/Restore';
import type { RiskRecordingSettings } from '../../constants/riskRecordingSettings';

type Props = {
  value: RiskRecordingSettings;
  onChange: (next: RiskRecordingSettings) => void;
  onSave: () => void;
  onResetDefaults: () => void;
  saving?: boolean;
};

const RiskRecordingSettingsCard: React.FC<Props> = ({
  value,
  onChange,
  onSave,
  onResetDefaults,
  saving = false,
}) => (
  <Card>
    <CardHeader
      title="이벤트 발생 시 영상 보관 (게이트웨이)"
      subheader="시설에 현장 게이트웨이(site_gateway_enabled)가 켜져 있고 HLS가 중앙에 올라올 때만 동작. 이벤트 발생 시 감지 시점 기준 앞·뒤 구간을 별도 보관."
      action={
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<RestoreIcon />}
            onClick={onResetDefaults}
            disabled={saving}
          >
            기본값으로 되돌리기
          </Button>
          <Button
            size="small"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={onSave}
            disabled={saving}
          >
            {saving ? '저장 중…' : '저장'}
          </Button>
        </Box>
      }
    />
    <CardContent>
      <FormControlLabel
        control={
          <Switch
            checked={value.enabled}
            onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
          />
        }
        label="위험 시 녹화(증거 영상 보관) 사용"
      />
      <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 2 }}>
        OFF이면 이벤트만 기록하고 HLS 세그먼트는 롤링 보관만.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            margin="dense"
            type="number"
            label="앞(초) — pre-roll"
            helperText="감지 시점 이전 구간. 시스템 관리에 저장한 값이 적용됨."
            value={value.pre_seconds}
            inputProps={{ min: 1, max: 120, step: 1 }}
            disabled={!value.enabled}
            onChange={(e) =>
              onChange({ ...value, pre_seconds: Number(e.target.value) })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            margin="dense"
            type="number"
            label="뒤(초) — post-roll"
            helperText="감지 후 구간. 시스템 관리에 저장한 값이 적용됨"
            value={value.post_seconds}
            inputProps={{ min: 1, max: 120, step: 1 }}
            disabled={!value.enabled}
            onChange={(e) =>
              onChange({ ...value, post_seconds: Number(e.target.value) })
            }
          />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default RiskRecordingSettingsCard;
